import { ChevronRight } from 'lucide-react'

export interface BreadcrumbItem {
  id: number | null
  label: string
}

interface BreadcrumbBarProps {
  items: BreadcrumbItem[]
  onSelect: (id: number | null) => void
  className?: string
}

export function BreadcrumbBar({ items, onSelect, className = '' }: BreadcrumbBarProps) {
  return (
    <nav
      aria-label="Pfadnavigation"
      className={`flex flex-wrap items-center gap-1 text-sm text-gray-600 dark:text-gray-300 ${className}`.trim()}
    >
      {items.map((item, idx) => (
        <div key={`${item.label}-${idx}`} className="flex items-center gap-1">
          {idx > 0 && <ChevronRight className="h-4 w-4 text-gray-400 dark:text-gray-500" aria-hidden />}
          <button
            type="button"
            onClick={() => onSelect(item.id)}
            className="rounded px-1.5 py-0.5 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-800 dark:hover:text-gray-100"
          >
            {item.label}
          </button>
        </div>
      ))}
    </nav>
  )
}
